module.exports = "/build/web/svg/video.ca347cb8fc1c520c5990ff388d453eb6.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/video.svg
// module id = 235
// module chunks = 24